import { Cancel } from "@mui/icons-material";
import { Box, Button, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { FlexBox } from "./FlexBox";
import ShowBidPost from "./ShowBidPost";
import BidImageLightbox from "./BidImageLightbox";
import Snackbar1 from "./Snaclbar";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HourglassTopRoundedIcon from "@mui/icons-material/HourglassTopRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import WorkOutlineRoundedIcon from "@mui/icons-material/WorkOutlineRounded";
import { trackEventOnce } from "../asset/js/analytics";


function ShowBids() {
  const isAdmin = Boolean(Cookies.get("adminId") && Cookies.get("admintoken"));
  const [deleteBid, setDeleteBid] = useState(false);
  const [updateBid, setUpdateBid] = useState(false);
  const [ownerAccountDeleted, setOwnerAccountDeleted] = useState(false);
  const [post, setPost] = useState({});
  const [selectedImage, setSelectedImage] = useState("");
  const [lightboxImage, setLightboxImage] = useState("");
  const [approvebid, setApproveBid] = useState(true);
  const [skills, setSkills] = useState([]);
  const [mes, setMes] = useState("");
  const [show, setShow] = useState(false);
  const [missingBid, setMissingBid] = useState(false);
  const { id } = useParams();
  const [closed, setClosed] = useState(false);
  const [result, setResult] = useState([]);
  const [resultBid, setResultBid] = useState(true);
  const [adminApproving, setAdminApproving] = useState(false);
  const [adminApproveDone, setAdminApproveDone] = useState(false);
  const [adminApproveError, setAdminApproveError] = useState(false);
  const approvalResolvedRef = useRef(false);
  const [endBidDialogOpen, setEndBidDialogOpen] = useState(false);
  const [endingBid, setEndingBid] = useState(false);
  const [endBidError, setEndBidError] = useState("");
  const [endBidSubmitted, setEndBidSubmitted] = useState(false);
  const [safetyRecords, setSafetyRecords] = useState([]);
  useEffect(() => {
    trackEventOnce("tender_viewed", String(id), {
      tender_id: id,
      viewer_state: "authenticated",
      viewer_role: Cookies.get("profession") && Cookies.get("profession") !== "no" ? "professional" : "customer",
    });
  }, [id]);

  const parseSafetyJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const advanceIntentLabels = {
    no: "לא מתכוון לבקש תשלום לפני תחילת העבודה",
    possible: "ייתכן שיבקש מקדמה עבור חומרים או שריון מועד",
    yes: "מתכוון לבקש תשלום מראש בהתאם לסיכום עם הלקוח",
  };

  useEffect(() => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/getbid?id=${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      })
      .then((res) => {
        if (!Array.isArray(res.data?.Bid) || !res.data.Bid[0]) {
          setMissingBid(true);
          setShow(false);
          return;
        }
        setMissingBid(false);
        console.log(res);
        console.log(Cookies.get("id") === parseInt(res.data.Bid[0].user_id));
        setUpdateBid(
          parseInt(Cookies.get("id")) === parseInt(res.data.Bid[0].user_id)
            ? true
            : false
        );
        setClosed(
          parseInt(res.data.Bid[0] - new Date().getTime() < 0 ? true : false)
        );
        setResult(res.data.Biddeds);
        setOwnerAccountDeleted(Boolean(res.data.OwnerAccountDeleted));
        setSkills(res.data.Bid[0].skills.split(","));
        setPost(res.data.Bid[0]);
        setSelectedImage(
          String(res.data.Bid[0].images || "").split(",").map((item) => item.trim()).find(Boolean) || ""
        );
        setShow(true);
      })
      .catch((err) => {
        console.error("Tender load failed", err);
        // Never modify the session on missing tender or network errors.
        // ACCOUNT_BLOCKED remains handled by the existing global interceptor.
        if (err?.response?.status !== 403 || err?.response?.data?.error !== "ACCOUNT_BLOCKED") {
          setMissingBid(true);
          setShow(false);
        }
      });
  }, [id]);

  useEffect(() => {
    if (!isAdmin) return;
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/admin/transaction-safety?id=${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("admintoken")}`,
        },
      })
      .then((res) => setSafetyRecords(res.data.Records || []))
      .catch((err) => console.log(err));
  }, [id, isAdmin]);
  const loadFunction = () => {
    axios
      .get(`${process.env.React_APP_BACKEND_URL}/api/getbid?id=${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      })
      .then((res) => {
        console.log(res);
        setResult(res.data.Biddeds);
        setOwnerAccountDeleted(Boolean(res.data.OwnerAccountDeleted));
        setSkills(res.data.Bid[0].skills.split(","));
        setPost(res.data.Bid[0]);
        setSelectedImage((current) => current || (
          String(res.data.Bid[0].images || "").split(",").map((item) => item.trim()).find(Boolean) || ""
        ));
        setShow(true);
      })
      .catch((err) => console.log(err));
  };
  const handleDelete = () => {
    axios
      .delete(
        `${process.env.React_APP_BACKEND_URL}/api/deletebid?id=${post.id}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((e) => {
        console.log(e);
        setDeleteBid(true);
      })
      .catch((err) => console.log(err));
  };

  const handleEndBidNow = () => {
    if (endingBid || (!updateBid && !isAdmin) || result.length === 0) return;

    setEndingBid(true);
    setEndBidError("");

    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/endbid`,
        { id: post.id },
        {
          headers: {
            Authorization: `Bearer ${isAdmin ? Cookies.get("admintoken") : Cookies.get("token")}`,
          },
        }
      )
      .then((response) => {
        const endedDeadline = Number(response.data?.deadline) || Date.now() - 1000;
        setPost((previous) => ({ ...previous, deadline: endedDeadline }));
        setEndBidSubmitted(true);
        setEndBidDialogOpen(false);
        setApproveBid(false);
        setMes("המכרז הסתיים. תהליך קבלת התוצאות ייקח מספר דקות");
      })
      .catch((error) => {
        console.log(error);
        setEndBidError("לא הצלחנו לסיים את המכרז. לא בוצע שינוי, ואפשר לנסות שוב.");
      })
      .finally(() => setEndingBid(false));
  };
  const markAdminApprovalSuccess = () => {
    if (approvalResolvedRef.current) return;
    approvalResolvedRef.current = true;
    setAdminApproving(false);
    setAdminApproveError(false);
    setAdminApproveDone(true);
    setApproveBid(false);
    setMes("המכרז אושר ופורסם בהצלחה");
    setPost((prev) => ({ ...prev, status: 1 }));
  };

  const checkApprovedStatus = (attempt = 0) => {
    if (approvalResolvedRef.current || attempt >= 12) return;
    window.setTimeout(() => {
      axios
        .get(`${process.env.React_APP_BACKEND_URL}/api/getbid?id=${id}`, {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        })
        .then((res) => {
          const refreshedBid = res.data && res.data.Bid && res.data.Bid[0];
          if (refreshedBid && refreshedBid.status.toString() !== "0") {
            setPost(refreshedBid);
            setResult(res.data.Biddeds || []);
            markAdminApprovalSuccess();
          } else {
            checkApprovedStatus(attempt + 1);
          }
        })
        .catch(() => checkApprovedStatus(attempt + 1));
    }, attempt === 0 ? 1200 : 1500);
  };

  const handleApproveBid = () => {
    if (adminApproving) return;
    approvalResolvedRef.current = false;
    setAdminApproving(true);
    setAdminApproveDone(false);
    setAdminApproveError(false);
    checkApprovedStatus();

    axios
      .put(
        `${process.env.React_APP_BACKEND_URL}/api/admin/approvebid`,
        {
          id,
          deadline: new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getTime() + "",
          dateDeadline:
            new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getFullYear() +
            "-" +
            (new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMonth() + 1 < 10
              ? "0" + (new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMonth() + 1)
              : new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMonth() + 1) +
            "-" +
            (new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getDate() < 10
              ? "0" + new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getDate()
              : new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getDate()) +
            " " +
            (new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getHours() < 10
              ? "0" + new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getHours()
              : new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getHours()) +
            ":" +
            (new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMinutes() < 10
              ? "0" + new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMinutes()
              : new Date(Date.now() + parseInt(post.length1.toString()) + 10 * 6000).getMinutes()) +
            ":00",
        },
        { headers: { Authorization: `Bearer ${Cookies.get("admintoken")}` } }
      )
      .then((res) => {
        console.log(res);
        markAdminApprovalSuccess();
      })
      .catch((err) => {
        console.log(err);
        window.setTimeout(() => {
          if (!approvalResolvedRef.current) {
            setAdminApproving(false);
            setAdminApproveError(true);
          }
        }, 19000);
      });
  };

  let date = new Date();
  let time = parseInt(post.length1);
  var currentDate = Date.now() + time * 60 * 60 * 1000 + 10 * 6000;
  console.log(currentDate + " " + post.length1);
  let date1 = new Date(currentDate);
  return (
    <div sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
      {missingBid && !deleteBid && (
        <Box dir="rtl" sx={{ maxWidth: 620, mx: "auto", my: 5, p: 4, borderRadius: "20px", bgcolor: "#f5f9fc", textAlign: "center" }}>
          <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>המכרז אינו זמין</Typography>
          <Typography sx={{ mb: 3 }}>ייתכן שהמכרז נמחק או שלא ניתן להציג אותו כרגע.</Typography>
          <Button component={NavLink} to="/mybids" variant="contained">חזרה למכרזים שלי</Button>
        </Box>
      )}
      {deleteBid && (
        <Box sx={{ width: { xs: "92%", sm: "72%", md: "62%" }, maxWidth: "720px", margin: "32px auto", p: { xs: 2.5, sm: 3.5 }, textAlign: "center", borderRadius: "22px", border: "1px solid rgba(46,125,50,0.18)", background: "linear-gradient(135deg, #fff 0%, #f4fbf6 100%)", boxShadow: "0 12px 34px rgba(21,78,45,0.10)", fontFamily: `${process.env.REACT_APP_FONT}` }}>
          <CheckCircleOutlineRoundedIcon sx={{ fontSize: 48, color: "#2E7D32", mb: 1 }} />
          <Typography variant="h5" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#173A2A", mb: 0.7 }}>המכרז נמחק בהצלחה</Typography>
          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#607067", mb: 2.5 }}>המכרז הוסר ולא יוצג עוד לבעלי המקצוע.</Typography>
          <Button component={NavLink} to="/" variant="contained" startIcon={<HomeRoundedIcon />} sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, borderRadius: "14px", px: 3, py: 1.15, fontWeight: 700, textTransform: "none", boxShadow: "0 8px 18px rgba(25,118,210,0.18)" }}>חזרה למסך הבית</Button>
        </Box>
      )}
      {!missingBid && !approvebid && <Snackbar1 mes={mes} />}
      {show && !deleteBid && (
        <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
          {Cookies.get("adminId") && (
            <Box sx={{ marginTop: "20px", marginBottom: "20px" }}>
              <NavLink to={`/viewuserprofile/${post.user_id}`}>
                <Typography
                  variant="h6"
                  sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                >
                  קישור לפרופיל מפרסם העבודה{" "}
                </Typography>
              </NavLink>
              {approvebid && post.status.toString() === "0" && <FlexBox
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  backgroundColor: "#CDE6C9",
                  padding: "10px",
                  marginTop: "20px",
                  color: "white",
                }}
              >
                <p
                  style={{
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                    color: "black",
                  }}
                >
                  תרצה לאשר או להסיר את המכרז?
                </p>
                <FlexBox>
                   
                    <Button
                      variant="contained"
                      sx={{
                        fontFamily: `${process.env.REACT_APP_FONT}`,
                        backgroundColor: "white",
                        color: "black",
                      }}
                      disabled={adminApproving}
                      onClick={handleApproveBid}
                    >
                      אשר מכרז
                    </Button>
                  
                  <Button
                    variant="contained"
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      backgroundColor: "white",
                      color: "black",
                      margin: "0px 5px",
                    }}
                    onClick={handleDelete}
                  >
                    הסר מכרז
                  </Button>
                  <Button
                    sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}
                    variant="text"
                    onClick={(e) => setApproveBid(false)}
                    startIcon={<Cancel />}
                  ></Button>
                </FlexBox>
              </FlexBox>
              }
              {adminApproving && (
                <Box sx={{ mt: 1.5, p: 1.6, borderRadius: "14px", backgroundColor: "#F3F8FD", border: "1px solid rgba(25,118,210,0.16)", display: "flex", alignItems: "center", gap: 1, direction: "rtl" }}>
                  <HourglassTopRoundedIcon sx={{ color: "#1976D2" }} />
                  <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 700, color: "#25506F" }}>מאשר ומפרסם את המכרז... אין צורך לרענן את הדף.</Typography>
                </Box>
              )}
              {adminApproveDone && (
                <Box sx={{ mt: 1.5, p: 1.6, borderRadius: "14px", backgroundColor: "#F2FAF4", border: "1px solid rgba(46,125,50,0.18)", display: "flex", alignItems: "center", gap: 1, direction: "rtl" }}>
                  <CheckCircleOutlineRoundedIcon sx={{ color: "#2E7D32" }} />
                  <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#24552D" }}>המכרז אושר ופורסם בהצלחה.</Typography>
                </Box>
              )}
              {adminApproveError && (
                <Box sx={{ mt: 1.5, p: 1.6, borderRadius: "14px", backgroundColor: "#FFF7F3", border: "1px solid rgba(211,84,0,0.18)" }}>
                  <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 700, color: "#9A4A13" }}>לא התקבל חיווי סופי מהשרת. בדוק את סטטוס המכרז לפני ניסיון נוסף.</Typography>
                </Box>
              )}
              {safetyRecords.some((record) => record.safety_acknowledgement || record.professional_declaration) && (
                <Box dir="rtl" sx={{ mt: 2, p: { xs: 1.7, sm: 2.2 }, borderRadius: "18px", border: "1px solid #D8E7F4", backgroundColor: "#F8FBFF" }}>
                  <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 900, color: "#173F5F", mb: 1.3 }}>
                    תיעוד בטיחות והצהרות
                  </Typography>
                  {safetyRecords
                    .filter((record) => record.safety_acknowledgement || record.professional_declaration)
                    .map((record) => {
                      const safety = parseSafetyJson(record.safety_acknowledgement);
                      const declaration = parseSafetyJson(record.professional_declaration);
                      return (
                        <Box key={record.id} sx={{ p: 1.5, mb: 1.2, borderRadius: "14px", backgroundColor: "#FFFFFF", border: "1px solid #E4EDF5" }}>
                          <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#31546F" }}>
                            הצעה בסך ₪{record.bidAmount} | בעל מקצוע #{record.bidderId}
                          </Typography>
                          {safety && (
                            <>
                              <Typography sx={{ mt: 0.8, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", fontSize: "0.9rem" }}>
                                הלקוח אישר את חלון הבטיחות: {record.safety_acknowledged_at || safety.accepted_at}
                              </Typography>
                              <Box component="details" sx={{ mt: 0.7, color: "#526B7F", fontFamily: `${process.env.REACT_APP_FONT}`, fontSize: "0.86rem" }}>
                                <Box component="summary" sx={{ cursor: "pointer", fontWeight: 700 }}>הצג את נוסח חלון הבטיחות</Box>
                                <Box component="ul" sx={{ mt: 0.7, mb: 0, pr: 2.2 }}>
                                  {(safety.text || []).map((line, index) => <li key={index}>{line}</li>)}
                                </Box>
                              </Box>
                            </>
                          )}
                          {declaration && (
                            <>
                              <Typography sx={{ mt: 0.8, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#245E85", fontWeight: 700, fontSize: "0.9rem" }}>
                                הצהרת תשלום: {advanceIntentLabels[declaration.advance_intent] || "לא ידוע"}
                              </Typography>
                              <Typography sx={{ mt: 0.5, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", fontSize: "0.88rem" }}>
                                אושרה בתאריך: {record.professional_declared_at || declaration.accepted_at}
                              </Typography>
                              {declaration.professional && (
                                <Typography sx={{ mt: 0.5, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#526B7F", fontSize: "0.88rem", overflowWrap: "anywhere" }}>
                                  פרטים בזמן האישור: {declaration.professional.name || declaration.professional.username} | {declaration.professional.phone} | {declaration.professional.email}
                                </Typography>
                              )}
                              <Box component="details" sx={{ mt: 0.7, color: "#526B7F", fontFamily: `${process.env.REACT_APP_FONT}`, fontSize: "0.86rem" }}>
                                <Box component="summary" sx={{ cursor: "pointer", fontWeight: 700 }}>הצג את נוסח הצהרת בעל המקצוע</Box>
                                <Box component="ul" sx={{ mt: 0.7, mb: 0, pr: 2.2 }}>
                                  {(declaration.text || []).map((line, index) => <li key={index}>{line}</li>)}
                                </Box>
                              </Box>
                            </>
                          )}
                        </Box>
                      );
                    })}
                </Box>
              )}
            </Box>
          )}

          {ownerAccountDeleted && (
            <Box sx={{ mt: 2, p: 2, borderRadius: "16px", backgroundColor: "#FFF4E5", border: "1px solid #FFD59A", textAlign: "right" }}>
              <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#8A4B08" }}>
                החשבון של מפרסם המכרז אינו פעיל עוד
              </Typography>
              <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#7A5A35", mt: 0.5 }}>
                המכרז נסגר ולא ניתן לבצע בו פעולות נוספות.
              </Typography>
            </Box>
          )}

          {(updateBid || isAdmin) && !ownerAccountDeleted && post.deadline - new Date().getTime() > 0 && (
            <Box sx={{ mt: 2.5, p: { xs: 1.7, sm: 2 }, borderRadius: "18px", border: "1px solid rgba(25,118,210,0.13)", background: "linear-gradient(135deg, #ffffff 0%, #f7fbff 100%)", boxShadow: "0 8px 24px rgba(16,72,112,0.08)", display: "flex", alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", flexDirection: { xs: "column", sm: "row" }, gap: 1.5 }}>
              <Box sx={{ textAlign: "right" }}>
                <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#173F5F" }}>ניהול המכרז</Typography>
                <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#6A7A86", fontSize: "0.92rem" }}>{result.length === 0 ? "כל עוד לא התקבלו הצעות ניתן לערוך את פרטי המכרז." : isAdmin && !updateBid ? "כאדמין ניתן לסיים את המכרז ולעבור להצעה המובילה." : "התקבלו הצעות ולכן לא ניתן עוד לערוך את המכרז."}</Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 1 }}>
                {updateBid && result.length === 0 && (
                  <Button component={NavLink} to={`/updatebid/${post.id}`} variant="contained" startIcon={<EditRoundedIcon />} sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, borderRadius: "13px", px: 2.2, fontWeight: 700, textDecoration: "none", textTransform: "none", boxShadow: "0 7px 16px rgba(25,118,210,0.16)" }}>ערוך מכרז</Button>
                )}
                {result.length > 0 && (
                  <Button
                    variant="contained"
                    startIcon={<EmojiEventsRoundedIcon />}
                    onClick={() => {
                      setEndBidError("");
                      setEndBidDialogOpen(true);
                    }}
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      borderRadius: "13px",
                      px: 2.2,
                      fontWeight: 800,
                      textTransform: "none",
                      background: "linear-gradient(135deg, #F59A23, #FF870A)",
                      boxShadow: "0 7px 16px rgba(245,154,35,0.22)",
                      "&:hover": { background: "linear-gradient(135deg, #ED901C, #F77D00)" },
                    }}
                  >
                    סיים ובחר בהצעה המובילה
                  </Button>
                )}
                {updateBid && result.length === 0 && (
                  <Button variant="outlined" startIcon={<DeleteOutlineRoundedIcon />} onClick={handleDelete} sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, borderRadius: "13px", px: 2.2, fontWeight: 700, color: "#B3261E", borderColor: "rgba(179,38,30,0.35)", textTransform: "none", "&:hover": { borderColor: "#B3261E", backgroundColor: "rgba(179,38,30,0.04)" } }}>מחק מכרז</Button>
                )}
              </Box>
            </Box>
          )}
          <Dialog
            open={endBidDialogOpen}
            onClose={endingBid ? undefined : () => setEndBidDialogOpen(false)}
            fullWidth
            maxWidth="xs"
            PaperProps={{ sx: { borderRadius: "22px", direction: "rtl", p: 0.5 } }}
          >
            <DialogTitle sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 900, color: "#173F5F", pb: 1 }}>
              לסיים את המכרז עכשיו?
            </DialogTitle>
            <DialogContent>
              <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#5F7280", lineHeight: 1.65 }}>
                המכרז ייסגר להצעות חדשות. לאחר הכנת התוצאות תוכלו לאשר את בעל המקצוע שנמצא כעת במקום הראשון.
              </Typography>
              <Typography sx={{ mt: 1.2, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#9A4A13", fontWeight: 700, fontSize: "0.9rem" }}>
                לאחר הסיום לא ניתן לפתוח מחדש את המכרז.
              </Typography>
              {endBidError && (
                <Typography sx={{ mt: 1.5, fontFamily: `${process.env.REACT_APP_FONT}`, color: "#B3261E", fontWeight: 700 }}>
                  {endBidError}
                </Typography>
              )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
              <Button disabled={endingBid} onClick={() => setEndBidDialogOpen(false)} sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 700, borderRadius: "12px" }}>
                ביטול
              </Button>
              <Button
                disabled={endingBid}
                onClick={handleEndBidNow}
                variant="contained"
                startIcon={endingBid ? <CircularProgress size={18} color="inherit" /> : <EmojiEventsRoundedIcon />}
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, borderRadius: "12px", textTransform: "none", background: "linear-gradient(135deg, #F59A23, #FF870A)" }}
              >
                {endingBid ? "מסיים את המכרז..." : "כן, סיים את המכרז"}
              </Button>
            </DialogActions>
          </Dialog>
          {endBidSubmitted && (
            <Box sx={{ mt: 2.5, p: { xs: 1.7, sm: 2 }, borderRadius: "18px", border: "1px solid rgba(25,118,210,0.16)", background: "linear-gradient(135deg, #ffffff 0%, #f3f9ff 100%)", display: "flex", alignItems: "center", gap: 1.3, direction: "rtl" }}>
              <HourglassTopRoundedIcon sx={{ color: "#1976D2" }} />
              <Box>
                <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#173F5F" }}>המכרז הסתיים בהצלחה</Typography>
                <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#667D8C", fontSize: "0.9rem" }}>תהליך קבלת התוצאות ייקח מספר דקות. נעדכן את המשתמשים כשהתוצאות יהיו מוכנות.</Typography>
              </Box>
            </Box>
          )}
          {post.deadline - new Date().getTime() <= 0 && resultBid && !endBidSubmitted && (
            <Box
              sx={{
                mt: 2.5,
                p: { xs: 1.7, sm: 2 },
                borderRadius: "18px",
                border: "1px solid rgba(25,118,210,0.16)",
                borderRight: "4px solid #F59A23",
                background:
                  "linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(239,247,255,1) 100%)",
                boxShadow: "0 8px 24px rgba(16,72,112,0.09)",
                display: "flex",
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  minWidth: 0,
                }}
              >
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    flexShrink: 0,
                    borderRadius: "13px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#1976D2",
                    backgroundColor: "rgba(25,118,210,0.09)",
                  }}
                >
                  <QueryStatsIcon />
                </Box>

                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      color: "#153F5D",
                      fontWeight: 800,
                      fontSize: { xs: "1rem", sm: "1.08rem" },
                      lineHeight: 1.25,
                    }}
                  >
                    המכרז הסתיים - התוצאות מוכנות
                  </Typography>
                  <Typography
                    sx={{
                      mt: 0.35,
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      color: "#667D8C",
                      fontSize: { xs: "0.84rem", sm: "0.9rem" },
                    }}
                  >
                    לצפייה בהצעה המובילה ובהמשך התהליך
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.75,
                  flexShrink: 0,
                }}
              >
                <NavLink
                  style={{ textDecoration: "none", flex: 1 }}
                  to={isAdmin ? `/admin/result/${post.id}` : `/result/${post.id}`}
                >
                  <Button
                    variant="contained"
                    endIcon={<QueryStatsIcon sx={{ fontSize: 18 }} />}
                    sx={{
                      minHeight: 38,
                      px: { xs: 1.8, sm: 2.1 },
                      borderRadius: "999px",
                      fontFamily: `${process.env.REACT_APP_FONT}`,
                      fontWeight: 700,
                      fontSize: "0.88rem",
                      textTransform: "none",
                      color: "#FFFFFF",
                      background: "linear-gradient(135deg, #F59A23, #FF870A)",
                      boxShadow: "0 4px 12px rgba(245,154,35,0.20)",
                      whiteSpace: "nowrap",
                      "& .MuiButton-endIcon": {
                        marginRight: "7px",
                        marginLeft: 0,
                      },
                      "&:hover": {
                        background: "linear-gradient(135deg, #ED901C, #F77D00)",
                        boxShadow: "0 6px 15px rgba(245,154,35,0.26)",
                        transform: "translateY(-1px)",
                      },
                      transition: "all .18s ease",
                    }}
                  >
                    לתוצאות
                  </Button>
                </NavLink>

                <Button
                  aria-label="הסתר הודעת תוצאות"
                  sx={{
                    minWidth: 36,
                    width: 36,
                    height: 36,
                    p: 0,
                    borderRadius: "10px",
                    color: "#8295A3",
                    "&:hover": {
                      backgroundColor: "rgba(21,63,93,0.06)",
                      color: "#153F5D",
                    },
                  }}
                  variant="text"
                  onClick={() => setResultBid(false)}
                >
                  <Cancel fontSize="small" />
                </Button>
              </Box>
            </Box>
          )}
          <Box
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              marginTop: "20px",
              p: { xs: 2, sm: 2.5, md: 3 },
              borderRadius: { xs: 3, md: 4 },
              color: "#17394D",
              background: "linear-gradient(135deg, #FFFFFF 0%, #F1F9FE 100%)",
              border: "1px solid #DCEAF3",
              borderRight: "5px solid #1597DF",
              boxShadow: "0 12px 34px rgba(31, 62, 86, .09)",
            }}
          >
            <Typography
              component="h1"
              sx={{
                fontFamily: `${process.env.REACT_APP_FONT}`,
                fontWeight: 900,
                fontSize: { xs: "1.4rem", sm: "1.65rem", md: "1.85rem" },
                lineHeight: 1.3,
                color: "#17394D",
              }}
            >
              {post.title}
            </Typography>
            <Stack direction="row" useFlexGap flexWrap="wrap" spacing={1} sx={{ mt: 1.5 }}>
              {post.area && (
                <Chip
                  icon={<LocationOnOutlinedIcon />}
                  label={post.area}
                  sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, bgcolor: "#EAF6FE", color: "#145F8E", fontWeight: 800, border: "1px solid #CFE8F7" }}
                />
              )}
              {skills.filter(Boolean).map((skill, index) => (
                <Chip
                  key={`${skill}-${index}`}
                  icon={<WorkOutlineRoundedIcon />}
                  label={skill}
                  sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, bgcolor: "#F2F0FF", color: "#5D4A98", fontWeight: 800, border: "1px solid #E0DAFA" }}
                />
              ))}
            </Stack>
          </Box>
          <FlexBox
            sx={{
              fontFamily: `${process.env.REACT_APP_FONT}`,
              marginTop: "20px",
              alignItems: "normal",
            }}
          >
            <ShowBidPost
              post={post}
              selectedImage={selectedImage}
              skills={skills}
              result={result}
              bidId={id}
              bidderId={post.user_id}
              loadFunction={loadFunction}
              onSelectImage={setSelectedImage}
              onOpenImage={setLightboxImage}
            />
          </FlexBox>
          <BidImageLightbox
            images={String(post.images || "").split(",")}
            initialImage={lightboxImage}
            open={Boolean(lightboxImage)}
            onClose={() => setLightboxImage("")}
          />
        </Box>
      )}
    </div>
  );
}

export default ShowBids;
